import moment from 'moment'
import { useState } from 'react'
import { Button, Card, Modal, Table } from 'react-bootstrap'

import Loading from '../../../../templates/UI/Loading/Loading'

import useCallApi from '../../../../hooks/useCallApi'
import callAPI from '../../../../helpers/callAPI'

const VirusTotal = ({ manager, advertiserId }) => {


    const { dataLoaded, data, refetch } = useCallApi('virusTotal', 'GET', {}, [manager, advertiserId])

    return (
        <Card className="mb-3">
            <Card.Header className="d-flex justify-content-between align-items-center">
                <span>Virus Total Domains</span>
            </Card.Header>

            <Card.Body className="p-0 overflow-auto table-container-scroll">
                <Table striped hover className="w-100 m-0">
                    <thead>
                        <tr className="text-secondary">
                            <th>Domain</th>
                            <th>Malicious</th>
                            <th>Suspicious</th>
                            <th>Timeout</th>
                            <th>Last Scan</th>
                            <th>Suppressed</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataLoaded ? (
                            <>
                                {!data || data.length === 0 ? (
                                    <tr>
                                        <td colSpan={12}>No data.</td>
                                    </tr>
                                ) : (
                                    data.data.map((domain) => (
                                        <tr key={domain.domain_URL}>
                                            <td>{domain.domain_URL}</td>
                                            <td>{domain.virustotal_malicious}</td>
                                            <td>{domain.virustotal_suspicious}</td>
                                            <td>{domain.virustotal_timeout}</td>
                                            <td>{moment(domain.virustotal_last_checked).utc().format('DD/MM/YYYY HH:mm:ss')}</td>
                                            <td><input type="checkbox" checked={domain.mb_alert_suppressed === 'Y'} onChange={async (e) => {
                                                await callAPI(`virusTotal/suppress`, 'PUT', {
                                                    domain_URL: domain.domain_URL,
                                                    mb_alert_suppressed: e.target.checked ? 'Y' : 'N'
                                                })
                                                refetch()
                                            }} /></td>
                                        </tr>
                                    ))
                                )}
                            </>
                        ) : (
                            <tr>
                                <td colSpan={6} align="center">
                                    <Loading />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    )
}

export default VirusTotal
